import { useEffect, useState } from "react";
import { tokenStore } from "@/lib/api";

// Sign-in/up lives in the central HikmahVerses login app — bounce there and
// have it send the user (with a gateway token) back to /sso/callback.
const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || "http://localhost:3007/login";

// SsoCallback stamps this just before landing in the app. If we're back here
// within seconds, the token we were just given was rejected — bouncing again
// would loop forever, so stop and say so instead.
const LOOP_WINDOW_MS = 20000;
const recentlySignedIn = () => {
  try { return Date.now() - Number(sessionStorage.getItem("hv_sso_cb") || 0) < LOOP_WINDOW_MS; } catch { return false; }
};

export default function ExternalLogin({ mode }) {
  const [looped] = useState(recentlySignedIn);

  useEffect(() => {
    if (looped) {
      tokenStore.clear(); // the rejected token must not stay behind
      return;
    }
    const u = new URL(LOGIN_URL);
    u.searchParams.set("redirect", `${window.location.origin}/sso/callback`);
    if (mode === "register") u.searchParams.set("mode", "register");
    window.location.replace(u.toString());
  }, [mode, looped]);

  if (!looped) return null;

  const retry = () => {
    try { sessionStorage.removeItem("hv_sso_cb"); sessionStorage.removeItem("hv_sso_checked"); } catch { /* ignore */ }
    const u = new URL(LOGIN_URL);
    u.searchParams.set("redirect", `${window.location.origin}/sso/callback`);
    u.searchParams.set("switch", "1"); // show the form, don't auto-sign-in again
    window.location.replace(u.toString());
  };

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, fontFamily: "system-ui, sans-serif", textAlign: "center" }}>
      <div style={{ maxWidth: 420 }}>
        <h1 style={{ fontSize: 22, marginBottom: 8 }}>We couldn&apos;t sign you in</h1>
        <p style={{ color: "#555", marginBottom: 16 }}>
          You signed in, but this app didn&apos;t accept the session. Please try again; if it keeps happening, contact support.
        </p>
        <button onClick={retry} style={{ padding: "10px 20px", borderRadius: 999, border: 0, background: "#1E3F33", color: "#fff", cursor: "pointer" }}>
          Try signing in again
        </button>
      </div>
    </div>
  );
}
